import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/i18n/locales/en/common.json";
import it from "@/i18n/locales/it/common.json";
import es from "@/i18n/locales/es/common.json";
import fr from "@/i18n/locales/fr/common.json";
import de from "@/i18n/locales/de/common.json";
// Phase 7B — extension to 15 languages
import pt from "@/i18n/locales/pt/common.json";
import nl from "@/i18n/locales/nl/common.json";
import pl from "@/i18n/locales/pl/common.json";
import tr from "@/i18n/locales/tr/common.json";
import ja from "@/i18n/locales/ja/common.json";
import zhCN from "@/i18n/locales/zh-CN/common.json";
import ru from "@/i18n/locales/ru/common.json";
import ar from "@/i18n/locales/ar/common.json";
import ko from "@/i18n/locales/ko/common.json";
import hi from "@/i18n/locales/hi/common.json";

// F8.2 · LandingV2 namespace (Phase 2). All 15 locales native — EN + IT
// authored manually, other 13 auto-translated via gpt-4o-mini (scripts/
// f8_translate_landing_v2.py).
import lv2_en from "@/pages/landing-v2/i18n/landing-v2.en.json";
import lv2_it from "@/pages/landing-v2/i18n/landing-v2.it.json";
import lv2_es from "@/pages/landing-v2/i18n/landing-v2.es.json";
import lv2_fr from "@/pages/landing-v2/i18n/landing-v2.fr.json";
import lv2_de from "@/pages/landing-v2/i18n/landing-v2.de.json";
import lv2_pt from "@/pages/landing-v2/i18n/landing-v2.pt.json";
import lv2_nl from "@/pages/landing-v2/i18n/landing-v2.nl.json";
import lv2_pl from "@/pages/landing-v2/i18n/landing-v2.pl.json";
import lv2_tr from "@/pages/landing-v2/i18n/landing-v2.tr.json";
import lv2_ja from "@/pages/landing-v2/i18n/landing-v2.ja.json";
import lv2_zhCN from "@/pages/landing-v2/i18n/landing-v2.zh-CN.json";
import lv2_ru from "@/pages/landing-v2/i18n/landing-v2.ru.json";
import lv2_ar from "@/pages/landing-v2/i18n/landing-v2.ar.json";
import lv2_ko from "@/pages/landing-v2/i18n/landing-v2.ko.json";
import lv2_hi from "@/pages/landing-v2/i18n/landing-v2.hi.json";

// FASE J · landing_v3 namespace deleted together with the LandingV3
// SPA page. Only landing_v2 (consumed by the AuthModal/LoginForm/
// SignupForm/ForgotPassword translations) survives.
// F9.2 WAVE 2B · HeaderV3 namespace (F9.7 FASE 2 · 15 locales).
import hv3_it from "@/components/header-v3/i18n/header-v3.it.json";
import hv3_en from "@/components/header-v3/i18n/header-v3.en.json";
import hv3_es from "@/components/header-v3/i18n/header-v3.es.json";
import hv3_fr from "@/components/header-v3/i18n/header-v3.fr.json";
import hv3_de from "@/components/header-v3/i18n/header-v3.de.json";
import hv3_pt from "@/components/header-v3/i18n/header-v3.pt.json";
import hv3_nl from "@/components/header-v3/i18n/header-v3.nl.json";
import hv3_pl from "@/components/header-v3/i18n/header-v3.pl.json";
import hv3_tr from "@/components/header-v3/i18n/header-v3.tr.json";
import hv3_ja from "@/components/header-v3/i18n/header-v3.ja.json";
import hv3_zhCN from "@/components/header-v3/i18n/header-v3.zh-CN.json";
import hv3_ru from "@/components/header-v3/i18n/header-v3.ru.json";
import hv3_ar from "@/components/header-v3/i18n/header-v3.ar.json";
import hv3_ko from "@/components/header-v3/i18n/header-v3.ko.json";
import hv3_hi from "@/components/header-v3/i18n/header-v3.hi.json";
// F9.2 WAVE 2C · DashboardV3 namespace (F9.7 FASE 2 · 15 locales).
import dv3_it from "@/pages/dashboard-v3/i18n/dashboard-v3.it.json";
import dv3_en from "@/pages/dashboard-v3/i18n/dashboard-v3.en.json";
import dv3_es from "@/pages/dashboard-v3/i18n/dashboard-v3.es.json";
import dv3_fr from "@/pages/dashboard-v3/i18n/dashboard-v3.fr.json";
import dv3_de from "@/pages/dashboard-v3/i18n/dashboard-v3.de.json";
import dv3_pt from "@/pages/dashboard-v3/i18n/dashboard-v3.pt.json";
import dv3_nl from "@/pages/dashboard-v3/i18n/dashboard-v3.nl.json";
import dv3_pl from "@/pages/dashboard-v3/i18n/dashboard-v3.pl.json";
import dv3_tr from "@/pages/dashboard-v3/i18n/dashboard-v3.tr.json";
import dv3_ja from "@/pages/dashboard-v3/i18n/dashboard-v3.ja.json";
import dv3_zhCN from "@/pages/dashboard-v3/i18n/dashboard-v3.zh-CN.json";
import dv3_ru from "@/pages/dashboard-v3/i18n/dashboard-v3.ru.json";
import dv3_ar from "@/pages/dashboard-v3/i18n/dashboard-v3.ar.json";
import dv3_ko from "@/pages/dashboard-v3/i18n/dashboard-v3.ko.json";
import dv3_hi from "@/pages/dashboard-v3/i18n/dashboard-v3.hi.json";

// F13.1 Wave D · f13_pages namespace (19 new Legal/Product/Resources pages).
// Lazy-loading strategy: EN is statically bundled as the fallback source;
// the 14 other locales are dynamically imported per-language the first time
// they are needed, then cached by i18next. This keeps the main bundle lean.
import f13_en from "@/i18n/locales/en/f13_pages.json";

// F13.5 · P2 · pricing_f11 namespace (route-based lazy).
// F83 · DEPRECATED · the PricingF11 orphan was removed in Phase I
// Wave 1.20. We keep locale JSON files on disk (no git churn) but
// stop registering the namespace to shave ~5 kB off the main chunk.

// FASE J · landing_v4 namespace + 15 locale JSON files + lazy loaders
// deleted together with LandingV4Page. The authoritative landing is
// now served by Next.js SSR at `/`.
// F18 Phase C · admin_rendering (admin-only, EN + IT inline, others fallback to EN)
import admin_rendering_en from "@/i18n/locales/en/admin_rendering.json";
import admin_rendering_it from "@/i18n/locales/it/admin_rendering.json";

// Loader map: lang → () => import(...).  Webpack creates one tiny chunk per
// language file (~5–10 kB gzip each). We DO NOT eagerly import these.
const F13_LAZY_LOADERS = {
    it: () => import(/* webpackChunkName: "f13-pages-it" */ "@/i18n/locales/it/f13_pages.json"),
    es: () => import(/* webpackChunkName: "f13-pages-es" */ "@/i18n/locales/es/f13_pages.json"),
    fr: () => import(/* webpackChunkName: "f13-pages-fr" */ "@/i18n/locales/fr/f13_pages.json"),
    de: () => import(/* webpackChunkName: "f13-pages-de" */ "@/i18n/locales/de/f13_pages.json"),
    pt: () => import(/* webpackChunkName: "f13-pages-pt" */ "@/i18n/locales/pt/f13_pages.json"),
    nl: () => import(/* webpackChunkName: "f13-pages-nl" */ "@/i18n/locales/nl/f13_pages.json"),
    pl: () => import(/* webpackChunkName: "f13-pages-pl" */ "@/i18n/locales/pl/f13_pages.json"),
    tr: () => import(/* webpackChunkName: "f13-pages-tr" */ "@/i18n/locales/tr/f13_pages.json"),
    ja: () => import(/* webpackChunkName: "f13-pages-ja" */ "@/i18n/locales/ja/f13_pages.json"),
    "zh-CN": () => import(/* webpackChunkName: "f13-pages-zh-CN" */ "@/i18n/locales/zh-CN/f13_pages.json"),
    ru: () => import(/* webpackChunkName: "f13-pages-ru" */ "@/i18n/locales/ru/f13_pages.json"),
    ar: () => import(/* webpackChunkName: "f13-pages-ar" */ "@/i18n/locales/ar/f13_pages.json"),
    ko: () => import(/* webpackChunkName: "f13-pages-ko" */ "@/i18n/locales/ko/f13_pages.json"),
    hi: () => import(/* webpackChunkName: "f13-pages-hi" */ "@/i18n/locales/hi/f13_pages.json"),
};

// F83 · PRICING_F11_LAZY_LOADERS removed · the PricingF11 orphan page
// was deleted in Phase I Wave 1.20. Locale JSON files are kept on disk
// (zero git churn) but no longer registered as a resource bundle.

// FASE J · LANDING_V4_LAZY_LOADERS removed (SPA LandingV4Page deleted).

const _f13LoadedLangs = new Set(["en"]);

export async function ensureF13PagesLoaded(lng) {
    const base = (lng || "en").split("-")[0];
    const code = lng === "zh-CN" ? "zh-CN" : base;
    if (_f13LoadedLangs.has(code)) return;
    const loader = F13_LAZY_LOADERS[code];
    if (!loader) return;
    try {
        const mod = await loader();
        // addResourceBundle fires i18n.store 'added' event, which
        // react-i18next listens to (bindI18nStore config above) and
        // triggers a re-render of every mounted <Trans> / useTranslation
        // hook consumer. No manual event emission needed.
        i18n.addResourceBundle(code, "f13_pages", mod.default || mod, true, true);
        _f13LoadedLangs.add(code);
    } catch (e) {
        // Silent fallback to EN — never block the UI.
        // eslint-disable-next-line no-console
        console.warn(`[i18n] f13_pages: failed to load ${code}`, e);
    }
}

export async function ensureLandingV4Loaded(_lng) {
    // FASE J · stub kept for backward-compat (callers may be lazy-
    // loaded chunks). No-op since landing_v4 namespace was deleted.
    return;
}

export const SUPPORTED_LNGS = [
    "en", "it", "es", "fr", "de",
    "pt", "nl", "pl", "tr", "ja", "zh-CN", "ru", "ar", "ko", "hi",
];

// Languages that require right-to-left layout.
export const RTL_LNGS = ["ar"];

// ============================================================
// Wave E.2 · navigator.language auto-detect (BLOCCO 2 · Known
// Limitation #19)
// ============================================================
//
// Historically the detection order was ``["localStorage"]`` only
// (Wave D.5 fix pass · ItalianNudge soft opt-in). Wave E.2 adds a
// **custom** navigator detector so first-visit users get a cookie
// banner in their browser language · with:
//
//   * precedence: ``localStorage`` wins over navigator (explicit
//     user choice is never overridden);
//   * safe allowlist: only the 5 ratified governance languages
//     (``it/en/es/fr/de``) are honoured from navigator · any other
//     locale (``ja``, ``zh-CN``, ``pt`` …) falls back to ``"it"``;
//   * no impact on main-app i18n: the explicit language switcher
//     writes localStorage and keeps precedence over navigator for
//     every subsequent visit.
//
// Why a *custom* named detector and NOT the built-in ``navigator``
// one? Because the global ``supportedLngs`` has 15 entries, so the
// built-in ``navigator`` would let ``ja-JP`` through as ``ja``,
// defeating the brief's "5-ratified-languages for banner"
// allowlist. A named custom detector is the smallest-surface way to
// apply the restriction *only* to the navigator path.

export const GLMS_BANNER_LANGS = ["it", "en", "es", "fr", "de"];
export const GLMS_BANNER_FALLBACK = "it";

export function _glmsNavigatorFilteredLookup() {
    // eslint-disable-next-line no-undef
    const raw = typeof navigator !== "undefined" && navigator.language
        ? navigator.language
        : "";
    const base = String(raw).split("-")[0].toLowerCase();
    if (GLMS_BANNER_LANGS.includes(base)) return base;
    return GLMS_BANNER_FALLBACK;
}

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
    name: "glmsNavigatorFiltered",
    lookup: _glmsNavigatorFilteredLookup,
    // No cacheUserLanguage override · the navigator-derived value
    // must NOT be written to localStorage (otherwise users would
    // never see the soft ItalianNudge opt-in prompt).
    cacheUserLanguage() {},
});

i18n.use(languageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { common: en, landing_v2: lv2_en, header_v3: hv3_en, dashboard_v3: dv3_en, f13_pages: f13_en, admin_rendering: admin_rendering_en },
            it: { common: it, landing_v2: lv2_it, header_v3: hv3_it, dashboard_v3: dv3_it, admin_rendering: admin_rendering_it },
            es: { common: es, landing_v2: lv2_es, header_v3: hv3_es, dashboard_v3: dv3_es },
            fr: { common: fr, landing_v2: lv2_fr, header_v3: hv3_fr, dashboard_v3: dv3_fr },
            de: { common: de, landing_v2: lv2_de, header_v3: hv3_de, dashboard_v3: dv3_de },
            pt: { common: pt, landing_v2: lv2_pt, header_v3: hv3_pt, dashboard_v3: dv3_pt },
            nl: { common: nl, landing_v2: lv2_nl, header_v3: hv3_nl, dashboard_v3: dv3_nl },
            pl: { common: pl, landing_v2: lv2_pl, header_v3: hv3_pl, dashboard_v3: dv3_pl },
            tr: { common: tr, landing_v2: lv2_tr, header_v3: hv3_tr, dashboard_v3: dv3_tr },
            ja: { common: ja, landing_v2: lv2_ja, header_v3: hv3_ja, dashboard_v3: dv3_ja },
            "zh-CN": { common: zhCN, landing_v2: lv2_zhCN, header_v3: hv3_zhCN, dashboard_v3: dv3_zhCN },
            ru: { common: ru, landing_v2: lv2_ru, header_v3: hv3_ru, dashboard_v3: dv3_ru },
            ar: { common: ar, landing_v2: lv2_ar, header_v3: hv3_ar, dashboard_v3: dv3_ar },
            ko: { common: ko, landing_v2: lv2_ko, header_v3: hv3_ko, dashboard_v3: dv3_ko },
            hi: { common: hi, landing_v2: lv2_hi, header_v3: hv3_hi, dashboard_v3: dv3_hi },
        },
        fallbackLng: "it",
        supportedLngs: SUPPORTED_LNGS,
        ns: ["common", "landing_v2", "header_v3", "dashboard_v3", "f13_pages", "admin_rendering"],
        defaultNS: "common",
        detection: {
            // Wave E.2 · BLOCCO 2 · navigator fallback with 5-lang
            // allowlist custom detector · see
            // ``_glmsNavigatorFilteredLookup`` and the registration
            // right after ``init()``. localStorage keeps priority ·
            // explicit user choices are never overridden by navigator.
            order: ["localStorage", "glmsNavigatorFiltered"],
            caches: ["localStorage"],
            // Phase II · Wave E.1c.4 · TD6 · migrated from ``glms_lang``
            // (M14 legacy) to the canonical Wave D ``glms_locale`` key.
            // Legacy ``glms_lang`` localStorage is intentionally ignored
            // post-D.6b migration window.
            lookupLocalStorage: "glms_locale",
        },
        interpolation: { escapeValue: false },
        returnEmptyString: false,
        // F13.1 Wave D · Make react-i18next consumers re-render when we
        // addResourceBundle a lazy-loaded namespace. Default is '' which
        // means store events are ignored.
        react: {
            bindI18n: "languageChanged loaded",
            bindI18nStore: "added removed",
            useSuspense: false,
        },
    });

// F13.1 Wave D · Lazy-load f13_pages for the active (non-EN) language on
// init + whenever the user switches language.
// F83 · pricing_f11 lazy-load removed (orphan page deleted).
// FASE J · landing_v4 lazy-load removed (SPA LandingV4Page deleted).
i18n.on("languageChanged", (lng) => {
    ensureF13PagesLoaded(lng);
    applyDocumentDirection(lng);
});
// Fire once at module load if the detected language is not EN.
if (i18n.language && !i18n.language.startsWith("en")) {
    ensureF13PagesLoaded(i18n.language);
}

// F13.4 · RTL direction handling.
// Languages that are written right-to-left. Includes Arabic (ar), Hebrew (he),
// Persian (fa) and Urdu (ur). Only `ar` is currently in SUPPORTED_LNGS but we
// keep the full list for future expansion. The function updates
// <html dir="…" lang="…"> so Tailwind logical properties (ms-*, me-*,
// text-start, text-end, start-*, end-*) flip automatically, and so screen
// readers announce the correct language.
const RTL_LANGS = new Set(["ar", "he", "fa", "ur"]);

export function isRtl(lng) {
    const base = (lng || "").split("-")[0].toLowerCase();
    return RTL_LANGS.has(base);
}

export function applyDocumentDirection(lng) {
    if (typeof document === "undefined") return;
    const dir = isRtl(lng) ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lng || "en");
}

// Apply at module load so the first paint already uses the correct direction.
if (typeof document !== "undefined") {
    applyDocumentDirection(i18n.language || "en");
}

export default i18n;
